import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container, Button, FormGroup, Navbar, Breadcrumb } from "react-bootstrap";
import "../add-details.css";

import { connect } from "react-redux";
import { isEmpty, find, isUndefined, filter } from "lodash";
import Spinner from "react-bootstrap/Spinner";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { IconButton } from "@material-ui/core";
import Select from "react-select";
import Swal from "sweetalert";
import { getVendorData } from "../Vendor/Vendor.action";
import { generateVendorReportPDF } from "./Receiving.action";
import { setHeading } from "../../../accounts/account.actions";
import IconMenu from "../../../drawer/IconMenu";
import { Link } from "react-router-dom";
// import { addReceiving, getPDFById, getReceiving } from "./Receiving.action";

const PurchaseVendorReport = (props) => {
  const [vendorId, setVendorId] = useState("");
  const [vendorName, setVendorName] = useState("");

  function uploadPurchase() {
    //   props.getReceivingPdf(ReceivingId);
    props.generateVendorReportPDF(vendorId);
    setVendorId("");
  }
  // vendorDataList
  const handleChangeVendor = (selectedOption) => {
    console.log(selectedOption, "sop");
    setVendorId(selectedOption.value);
    setVendorName(selectedOption.label);
  };
  const getVendorList =
    !isEmpty(props.vendorDataList) &&
    props.vendorDataList.map((x) => {
      let data = { value: x._id, label: x.vendorName };
      return data;
    });
  useEffect(() => {
    props.setHeading("Vendor Purchase Report");
    props.getVendorData();
  }, []);

  return (
    <>
     <Navbar style={{backgroundColor:'#81abd3'}}  >
      <Container>
        <Navbar.Brand style={{color:'white'}}><b>Sale Report</b></Navbar.Brand>
        <IconMenu/>
      </Container>
    </Navbar>
      {props.isFetchingVendor ? (
        <div className="loader-div">
          <Button variant="info" disabled>
            <Spinner
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
              variant="info"
            />
            {props.isFetchingReceiving ? "Loading..." : "Loading..."}
          </Button>
        </div>
      ) : (
        <Container fluid>
          <div className="main">
          <Row>
              <Breadcrumb>
                <Breadcrumb.Item ><Link to="/home"> Home</Link></Breadcrumb.Item>
                <Breadcrumb.Item ><Link to="/report">Report</Link> </Breadcrumb.Item>
                <Breadcrumb.Item active>Purchase Report</Breadcrumb.Item>
              </Breadcrumb>
            </Row>
            <Row>
              <Col lg="12" md="12" xs="12">
                <Form.Group className="mb-3" controlId="garana">
                  <Form.Label>
                    <b>Select Vendor *</b>
                  </Form.Label>
                  <Select
                    isDisabled={isEmpty(props.vendorDataList)}
                    placeholder="Select Vendor..."
                    onChange={handleChangeVendor}
                    options={getVendorList}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="sendDiv">
              {isEmpty(vendorId) ? (
                <Button disabled>Generate PDF</Button>
              ) : (
                <Button onClick={uploadPurchase}>Generate PDF</Button>
              )}
            </div>
          </div>
        </Container>
      )}
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    // getReceiving:()=>dispatch(getReceiving()),
    // getReceivingPdf:(id)=>dispatch(getPDFById(id)),
    getVendorData: () => dispatch(getVendorData()),
    generateVendorReportPDF: (vendorId) =>
      dispatch(generateVendorReportPDF(vendorId)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  // ReceivingList:state.RecivingReducer.ReceivingList,
  // isFetchingReceiving:state.RecivingReducer.isFetchingReceiving,
  purchaseVendorPDFList: state.RecivingReducer.purchaseVendorPDFList,
  isFetchingPurchaseVendorPDF:
    state.RecivingReducer.isFetchingPurchaseVendorPDF,
  vendorDataList: state.VendorReducer.vendorDataList,
  isFetchingVendor: state.VendorReducer.isFetchingVendor,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PurchaseVendorReport);
